module.exports = "/images/mandarin-company-training.jpg?053994cd7055ea422311b5295cf12b1c";